<!--
 * @Description: Type your file description
 * @Author: qiangwu
 * @LastEditors: qiangwu
 * @Date: 2020-11-19 10:20:10
 * @LastEditTime: 2020-12-16 16:03:06
 * @FilePath: \ensurance-front\src\components\sidebar-common\index.vue
-->
<template>
  <div class="sidebar-common">
    <el-menu
      :default-openeds="openeds"
      v-if="defaultActive !== '/integratedQuery/person_detail'"
      :default-active="defaultActive ? defaultActive : this.$route.path"
      class="el-menu-vertical-demo"
      @open="handleSelect"
      background-color="#2A2A2A"
      text-color="#E0E3E9"
      active-text-color="#F48F62"
      :router="true"
      unique-opened
    >
      <template v-for="menu in permissionMenus" :index="menu.path">
        <el-submenu v-if="menu.children" v-bind:key="menu.name">
          <template slot="title">
            <i :class="menu.icon"></i>
            <span>{{ menu.name }}</span>
          </template>
          <el-menu-item v-for="sub in menu.children" :key="sub.name" @click="selectMenu({ name: sub.name, label: sub.name, path: sub.path })" :index="sub.path">
            <i :class="sub.icon"></i>
            <span>{{ sub.name }}</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item v-else @click="selectMenu({ name: menu.name, label: menu.name, path: menu.path })" v-bind:key="menu.name" :index="menu.path">
          <i :class="menu.icon"></i>
          <span>{{ menu.name }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import enumRoles from '@/utils/enumRoles'
export default {
  data() {
    return {
      // 导航菜单默认值
      defaultActive: '',
      isActiveColor: '',
      enumRoles: enumRoles,
      isVisbelAdmin: false,
      openeds: ['/enrollmentRegistration', '/TwoDimensionalCode', '/ScanDetail', '/integratedQuery', '/systemSettings', '/enrollmentRegistration'],
      menus: [
        {
          name: '生成二维码',
          icon: 'el-icon-full-screen',
          path: '/TwoDimensionalCode'
        },
        {
          name: '扫一扫明细',
          icon: 'el-icon-document-copy',
          path: '/ScanDetail'
        },
        {
          name: '保单明细',
          icon: 'el-icon-s-order',
          path: '/EnsuranceList'
        },
        {
          name: '客户管理',
          icon: 'el-icon-s-custom',
          path: '/CustomerManagement'
        },
        {
          name: '系统设置',
          icon: 'el-icon-edit-outline',
          path: '/systemSettings/operation_record',
          children: [
            {
              name: '账号管理',
              icon: 'el-icon-user-solid',
              path: '/systemSettings/account_manage',
              permission: ['账号管理']
            },
            {
              name: '操作记录',
              icon: 'el-icon-notebook-2',
              path: '/systemSettings/operation_record',
              permission: ['查看操作记录']
            }
          ]
        }
      ]
    }
  },
  filters: {
    hasPermission(v) {}
  },
  methods: {
    selectMenu(item) {
      // 加入keepalive缓存
      this.$store.commit('addKeepAliveCache', item.name)
      // 添加tags标签
      // 访问wellcome 就代表home
      let name = item.name === 'wellcome' ? 'home' : item.name
      let submenu = {
        path: item.path,
        name: name,
        label: item.label
      }
      // 修改选中菜单
      this.$store.commit('selectMenu', submenu)
    },
    handleSelect(key, keyPath) {}
  },
  computed: {
    userRoles() {
      return this.$store.getters.userRoles
    },
    permissionMenus() {
      return this.menus
    }
  },
  created() {
    this.isVisbelAdmin = window.sessionStorage.getItem('IsAdmin')
    console.log(this.isVisbelAdmin)
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        if (newVal.path === '/integratedQuery/person_detail') {
          this.defaultActive = '/integratedQuery/person_list'
        }
      },
      immediate: true
    },
    isVisbelAdmin: {
      handler(newVal, oldVal) {
        this.isVisbelAdmin = newVal
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .sidebar-common {
    .el-menu {
      width: 100%;
      overflow-x: hidden;
    }
  }
  .el-menu-item,
  .el-submenu__title {
    height: 40px;
    line-height: 35px;
  }
  .el-menu-item {
    font-size: 16px;
    height: 50px !important;
    margin: 15px 5px;
  }
  .el-menu-item.is-active::after {
    content: '';
    position: absolute;
    display: inline-block;
    left: 0px;
    height: 40px;
    width: 200px;
    background-color: #ffffff !important;
    opacity: 0.2;
    border-radius: 19px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sidebar-common/index.vue